import axios from '../utils/axios';

export default function fetchNTCPremiumJobAssignees(adminId, params) {
    return axios.get(`/admin/${adminId}/ntc-premium-jobs-assignees`, { params })
        .then(res => res.data)
        .catch(err => err);
}
